import React, { useState, useEffect, useContext } from "react";
import { Grid } from "@mui/material";

import { timeStampToDate } from "../../../../utils/formats";
import Table from "../../subcomponents/Table";
import { retrieveWorkflowPessoa } from "../../../../services/frontCredito";

import { toast } from "react-toastify";

import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";

const style = {
  justify: "center",
};

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

const columns = [
  { id: "pedidoId", name: "Pedido", style },
  { id: "nomeItemWorkflow", name: "Descrição", style },
  { id: "nomeLista", name: "Classificação", style },
  { id: "dataLiberacao", name: "Data", render: timeStampToDate, style },
  { id: "observacao", name: "Observação", style },
  { id: "usuarioCadastramento", name: "Usuário", style },
];

const WorkflowClienteSection = (props) => {
  const { cpfCnpj } = props;

  const [totalElements, setTotalElements] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const classes = useStyles();

  const [filters, setFilters] = useState({
    cpfCnpj: cpfCnpj,
    pageable: {
      page: 0,
      size: 10,
      sortColumn: null,
      sortDirection: "ASC",
    },
  });

  useEffect(() => {
    getDataByFilters();
  }, [filters]);

  const getDataByFilters = () => {
    setIsLoading(true);
    setRows([]);
    setTotalElements(0);

    retrieveWorkflowPessoa(cpfCnpj, filters)
      .then((response) => {
        if (response && (response.status === 201 || response.status === 200)) {
          const {
            data: { content, total },
          } = response;

          setRows(content);
          setTotalElements(total);
        } else if (!response) {
          toast.error("Erro ao buscar os dados.");
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao buscar os dados.");
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handleChangePage = (p, newPage) => {
    setFilters({
      ...filters,
      cpfCnpj: cpfCnpj,
      pageable: {
        ...filters.pageable,
        page: newPage,
      },
    });
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Table
            loading={isLoading}
            noDataMessage="SEM DADOS."
            entries={rows}
            columns={columns}
          />
          <TablePagination
            component="div"
            classes={{
              toolbar: classes.toolbar,
              caption: classes.caption,
            }}
            count={totalElements}
            page={filters.pageable.page || 0}
            labelDisplayedRows={({ from, to, count }) =>
              `${from} - ${to} de ${count}`
            }
            onPageChange={handleChangePage}
            rowsPerPageOptions={[]}
            rowsPerPage={filters.pageable.size}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default WorkflowClienteSection;
